import { render, staticRenderFns } from "./Resource.vue.js?vue&type=template&id=5cb60972&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Resource.vue?vue&type=template&id=5cb60972&scoped=true"
import script from "./Resource.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue.js?vue&type=script&lang=js!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Resource.vue?vue&type=script&lang=js"
import style0 from "./Resource.vue.scss?vue&type=style&index=0&id=5cb60972&prod&lang=scss&scoped=true!=!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Resource.vue?vue&type=style&index=0&id=5cb60972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb60972",
  null
  
)

export default component.exports